module.exports = __webpack_public_path__ + "img/diamondMagic@2x.afd477f.jpg";